

export default function HighlightedCard({
    color, badgeText, headline, description, bulletPoints, statNumber, statDescription, footerText, imageURL, imageALT,
}) {

    const accent = color === "purple" ? "purple" : color === "yellow" ? "yellow" : color === "green" ? "green" : "blue";

    const shadowColor = {
        purple: "rgba(216, 180, 254, 0.9)",
        yellow: "rgba(253, 224, 71, 0.9)",
        green:  "rgba(134, 239, 172, 0.9)",
        blue:   "rgba(147, 197, 253, 0.9)",
    }[accent];

    const badgeCls = {
        purple: "bg-purple-100 ring-purple-800 text-purple-800",
        yellow: "bg-yellow-100 ring-yellow-700 text-yellow-800",
        green:  "bg-green-100 ring-green-700 text-green-800",
        blue:   "bg-blue-100 ring-blue-700 text-blue-800",
    }[accent];

    const checkColor = {
        purple: "text-purple-600",
        yellow: "text-yellow-600",
        green:  "text-green-600",
        blue:   "text-blue-600",
    }[accent];

    const innerCard = {
        purple: "bg-purple-200 border-purple-600 text-purple-900",
        yellow: "bg-yellow-200 border-yellow-600 text-yellow-900",
        green:  "bg-green-200 border-green-600 text-green-900",
        blue:   "bg-blue-200 border-blue-600 text-blue-900",
    }[accent];

    const statColor = {
        purple: "text-purple-800",
        yellow: "text-yellow-800",
        green:  "text-green-800",
        blue:   "text-blue-800",
    }[accent];

    return (
        <section
            className="rounded shadow-xl pl-2 md:pl-8 pr-2 py-2.5 mx-auto my-2 bg-white"
            style={{ boxShadow: `0px 0px 30px 10px ${shadowColor}` }}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-stretch">
                {/* Left column */}
                <div className="px-4 py-10 flex flex-col justify-between">
                    <div>
                        <div className={`inline-block px-4 py-1 rounded-full ring-2 text-sm font-semibold tracking-wide mb-6 ${badgeCls}`}>
                            {badgeText}
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                            {headline}
                        </h2>
                        <p className="text-gray-600 leading-relaxed mb-6">
                            {description}
                        </p>
                        {bulletPoints && (
                            <ul className="text-gray-700 grid grid-cols-1 md:grid-cols-2 gap-y-2">
                                {bulletPoints.map((point, i) => (
                                    <li key={i} className="flex items-start">
                                        <span className={`mr-2 ${checkColor}`}>✓</span>
                                        {point}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {footerText && (
                        <p className="mt-4 text-sm text-gray-400 italic">
                            {footerText}
                        </p>
                    )}
                </div>

                {/* Right column: image with stat overlay */}
                <div
                    className="relative w-full bg-cover bg-center bg-no-repeat rounded"
                    style={{ backgroundImage: `url(${imageURL})`, minHeight: "360px" }}
                >
                    <div className={`absolute bottom-4 left-6 rounded py-4 px-6 max-w-sm shadow-md border-l-8 ${innerCard}`}>
                        <div className={`text-2xl font-extrabold mb-2 ${statColor}`}>
                            {statNumber}
                        </div>
                        <p>{statDescription}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
